import { render, staticRenderFns } from "./savedCreditCards.vue?vue&type=template&id=12b5c0cb&lang=pug"
import script from "./savedCreditCards.vue?vue&type=script&lang=js"
export * from "./savedCreditCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports